import { render, staticRenderFns } from "./single-blog.vue?vue&type=template&id=53d5b276&"
import script from "./single-blog.vue?vue&type=script&lang=js&"
export * from "./single-blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports